import {
    POST_IMPORT_SERVICE_CLIENT_LOADING,
    POST_IMPORT_SERVICE_CLIENT_SUCCESS,
    POST_IMPORT_SERVICE_CLIENT_REJECT,
    POST_IMPORT_SERVICE_CLIENT_RESET,
} from "../../actions/importServiceClient/post";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    }
}

const importServiceClientReducer = (state = stateInit, action) => {
    switch (action.type) {

        // ------------- POST --------------------
        case POST_IMPORT_SERVICE_CLIENT_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_IMPORT_SERVICE_CLIENT_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_IMPORT_SERVICE_CLIENT_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_IMPORT_SERVICE_CLIENT_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        default: return state;
    }
}

export default importServiceClientReducer
